export const createCalculation = (state, val) => {
    state.quote_calculated = val
}